import { api } from '@/lib/api'
import type { AnalyzeStatementRow } from './types'

export const analyzeStatementsApi = {
  analyze: (fromDate: string, toDate: string) =>
    api.get<AnalyzeStatementRow[]>('/api/statements/analyze', { query: { fromDate, toDate } }),
}
